module.exports = __webpack_public_path__ + "img/Claudia-Martinez.78bd2c74.jpg";